import { LanguageDictContext } from "@/App";
import { useServerStatus } from "@/api/hooks";
import { useContext, useState } from "react";

export const useHooks = () => {
  const [open, setOpen] = useState(false);
  const langDict = useContext(LanguageDictContext);
  const { loading, error, data } = useServerStatus();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return {
    langDict, loading, error, data, open, handleClickOpen, handleClose
  }
}